/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
//import { GooglePlus } from '@awesome-cordova-plugins/google-plus/ngx';
import { Platform } from '@ionic/angular';
// import firebase from 'firebase/app';
import 'firebase/auth';
import { BehaviorSubject } from 'rxjs';
import { APP_CONSTANTS } from 'src/constants/constants';
import { BoxxOAuthTemplateMethod } from '../classes/OAuthTemplateMethod';
import { BoxxOAuthResponseProps } from '../contracts/IBoxxOAuth';
import { IGMBOAuthResponse } from '../contracts/IGmbOAuth';

declare const gapi: any; 
let auth2: any;
declare const google: any;

@Injectable({
  providedIn: 'root', //<-- in order to be a singleton
})
export class BoxxGMBOAuthService extends BoxxOAuthTemplateMethod {
  private myOauthLibLoaded$ = new BehaviorSubject<boolean>(false);
  //private readonly provider = new firebase.auth.GoogleAuthProvider();

  constructor(private platform: Platform, 
    //private googlePlus: GooglePlus
  ) {
    super(platform);

    this.platform.ready().then(() => {
      //in order to wait for the parent to set fiel isCordovaOrCapacitor, may be not needed
      setTimeout(() => {
        this.initializeGApiLib();
      }, 800);
    });
  }

  getProvider() {
    //return this.provider;
  }

  /**
   *
   * @param scopes space separated strings
   * @returns Promise<IGoogleOAuthResponse>
   */
  async nativeOAuth(scopes: string = ''): Promise<IGMBOAuthResponse> {
    return null;
    // try {
    //   console.log('scopes: ', scopes);
    //   const oauthResp = await this.googlePlus.login({
    //     scopes: ('https://www.googleapis.com/auth/business.manage' + scopes).trim(),
    //     offline: true, 
    //     responseType: 'code',
    //     webClientId: APP_CONSTANTS.gcpWebClientId,
    //   });

    //   const response: IGMBOAuthResponse = {
    //     authResponse: {
    //       accessToken: oauthResp.accessToken,
    //       userID: oauthResp.userId,
    //       code: oauthResp.serverAuthCode,
    //     },
    //     profileResponse: {
    //       firstName: oauthResp.givenName,
    //       lastName: oauthResp.familyName,
    //       email: oauthResp.email,
    //       imageUrl: oauthResp.imageUrl,
    //     },
    //   };

    //   return response;
    // } catch (e) {
    //   console.error('gmbNativeOAuth()', e);
    //   this.manageOAuthError(e);
    // }
  }

  async webOAuth(): Promise<BoxxOAuthResponseProps> {
    //google.accounts.id.prompt();
    try {
      const cscope = 'https://www.googleapis.com/auth/business.manage \
      https://www.googleapis.com/auth/userinfo.email \
      https://www.googleapis.com/auth/userinfo.profile \
      https://www.googleapis.com/auth/businesscommunications';

      return new Promise((resolve) => {
        google.accounts.oauth2.initCodeClient({
          client_id: APP_CONSTANTS.gcpWebClientId,
          scope: 'https://www.googleapis.com/auth/business.manage \
                 https://www.googleapis.com/auth/userinfo.email \
                 https://www.googleapis.com/auth/userinfo.profile \
                 https://www.googleapis.com/auth/businesscommunications',
          ux_mode: 'popup',
          redirect_uri: "https://your.domain/code_callback_endpoint",
          state: "YOUR_BINDING_VALUE",
          callback: async (dataCode) => {
                 const dataGMB: IGMBOAuthResponse = {
                  authResponse: {
                    accessToken: null,
                    userID: null,
                    code: dataCode.code,
                  },
                  profileResponse: {
                    firstName: null,
                    lastName: null,
                    email: null,
                    imageUrl: null,
                  },
                };            
                return resolve(dataGMB);

              },
        }).requestCode();
      });
    } catch (e) {
      console.error('gmbWebOAuth()', e);
      this.manageOAuthError(e);
    }
  }

  isOathLibLoaded() {
    return this.myOauthLibLoaded$.value;
  }

  get oauthLibLoaded$() {
    return this.myOauthLibLoaded$.asObservable();
  }

  private async initializeGApiLib() {
    //if (!this.isHybridPlatform) {
      //https://developers.google.com/identity/sign-in/web/reference#gapiauth2clientconfig
      if (auth2 === undefined) {
        // gapi.load('auth2', () => {
        //   gapi.auth2
        //     .init({
        //       client_id: APP_CONSTANTS.gcpWebClientId,
        //       // Scopes to request in addition to 'profile' and 'email'
        //       scope: 'https://www.googleapis.com/auth/plus.business.manage',
        //       access_type: 'offline',
        //       include_granted_scopes: true,
        //       immediate: true,
        //     })
        //     .then(resp => {
        //       auth2 = resp;
        //       this.myOauthLibLoaded$.next(true);
        //     });
        // });
        this.myOauthLibLoaded$.next(true);
        

      } else {
        this.myOauthLibLoaded$.next(true);
      }
    //}
  }

  handleCredentialResponse(response) {
    auth2 = response.credential;
    this.myOauthLibLoaded$.next(true);
  }
}
